import { AxiosResponse } from 'axios';
import apiClient from './client';
import { ApiResponseDto } from '../interfaces/apiResponse';
import {
  CreateServiceGroupDto,
  UpdateServiceGroupDto,
  ServiceGroup,
  ServiceGroupDto,
  serviceGroupDtoToDomain,
} from '../interfaces/service_group';

interface ServiceGroupsService {
  getServiceGroups(queryParams?: any): Promise<ServiceGroup[]>;
  createServiceGroup(serviceGroupDto: CreateServiceGroupDto): Promise<any>;
  updateServiceGroup(id: number, serviceGroupDto: UpdateServiceGroupDto): Promise<ServiceGroup>;
  deleteServiceGroup(id: number): Promise<void>;
}

const endpoints = {
  getServiceGroups: '/service-groups',
  createServiceGroup: `/service-groups`,
  updateServiceGroup: (id: number) =>`/service-groups/${id}`,
  deleteServiceGroup: (id: number) =>`/service-groups/${id}`,
}

export const serviceGroupService: ServiceGroupsService = {
  getServiceGroups: async (): Promise<ServiceGroup[]> => {
    const response: AxiosResponse<ApiResponseDto<ServiceGroupDto[]>> = await apiClient.get(endpoints.getServiceGroups);

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!
      .map((serviceGroupDto: ServiceGroupDto) => serviceGroupDtoToDomain(serviceGroupDto))
      .sort((a: ServiceGroupDto, b: ServiceGroupDto) => a.id - b.id);
  },

  createServiceGroup: async (serviceGroupDto: CreateServiceGroupDto): Promise<AxiosResponse<any>> => {
    return apiClient.post(endpoints.createServiceGroup, serviceGroupDto);
  },

  updateServiceGroup: async (id: number, serviceGroupDto: UpdateServiceGroupDto): Promise<ServiceGroup> => {
    const response: AxiosResponse<ApiResponseDto<ServiceGroupDto>> =
      await apiClient.put(endpoints.updateServiceGroup(id), serviceGroupDto);

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return serviceGroupDtoToDomain(response.data.data!);
  },

  deleteServiceGroup: async (id: number): Promise<void> => {
    const response: AxiosResponse<ApiResponseDto<any>> =
      await apiClient.delete(endpoints.deleteServiceGroup(id));

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }
  },
};
